import { getSessionFee } from "./pricing";

export const HOLD_BOOKING_DRAFT_KEY = "holdBookingDraft";

export function getHoldBookingDraft() {
  try {
    const raw = sessionStorage.getItem(HOLD_BOOKING_DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

export function saveHoldBookingDraft(draft) {
  sessionStorage.setItem(HOLD_BOOKING_DRAFT_KEY, JSON.stringify(draft));
  // Keep compatibility with reused slot/detail components that read sessionStorage.user.
  sessionStorage.setItem("user", JSON.stringify(draft));
}

export function clearHoldBookingDraft() {
  sessionStorage.removeItem(HOLD_BOOKING_DRAFT_KEY);
}

export function computeHoldAmount(city, config, partnerSlug) {
  return getSessionFee({ partnerSlug, config });
}

export function buildHoldEndTime(startTime) {
  const start = new Date(startTime);
  if (Number.isNaN(start.getTime())) return null;
  const end = new Date(start);
  end.setMinutes(end.getMinutes() + 60);
  return end.toISOString();
}

export function formatDisplayDate(dateValue) {
  if (!dateValue) return "";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function formatDisplayTime(dateValue) {
  if (!dateValue) return "";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function getRemainingTimeMs(expiresAt) {
  if (!expiresAt) return 0;
  const expiry = new Date(expiresAt).getTime();
  if (Number.isNaN(expiry)) return 0;
  return Math.max(0, expiry - Date.now());
}

export function formatCountdown(remainingMs) {
  const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (totalSeconds % 60).toString().padStart(2, "0");
  return `${minutes}:${seconds}`;
}

export function buildHoldWhatsappMessage({ patientName, bookingLink, minutes = 15 }) {
  return `Hi ${patientName},\n\nKindly confirm your physiotherapy session using the link below:\n\n${bookingLink}\n\nThis slot is reserved for you for the next ${minutes} minutes.`;
}
